export default __webpack_public_path__ + "static/media/siminn-icons.8c04bd96.eot";